<template lang='pug' src='./navigation-desktop.pug'></template>

<script>

export default {
  computed: {
    props () {
      return this.$store.state.app.nav
    },
    links () {
      return this.$router.options.routes
    }
  },
  data () {
    return {
      left: 0,
      height: 0,
      dropdownSide: false,
      dropdownShow: false,
      showing: null,
      dropdownSmooth: false
    }
  },
  methods: {
    pageLink (i) {
      this.$router.push(i.path)
    },
    hoverDropdown (i, k) {
      if (!k.children) {
        this.dropdownLeave()
      }
      let selected = i - 1
      let left = this.$refs.root[selected].offsetLeft
      let width = this.$refs.root[selected].clientWidth
      this.dropdownSide = k.navigation
      this.showing = selected + 1
      this.left = left + width / 2 + 'px'
      setTimeout(() => {
        this.height = this.$refs.link[selected].clientHeight + 'px'
      }, 10)
    },
    dropdownActive () {
      this.dropdownShow = true
      setTimeout(() => {
        this.dropdownSmooth = true
      }, 500)
    },
    dropdownLeave () {
      this.dropdownShow = false
      this.dropdownSmooth = false
    }
  }
}
</script>



// WEBPACK FOOTER //
// navigation-desktop.vue?200ab44b